import { render } from "./block_master.vue?vue&type=template&id=69e7e34e&scoped=true"
import script from "./block_master.vue?vue&type=script&lang=js"
export * from "./block_master.vue?vue&type=script&lang=js"

import "./block_master.vue?vue&type=style&index=0&id=69e7e34e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e7e34e"]])

export default __exports__